import EmailCaptureFormComponent from './email-capture-form.component';

export default class EmailCaptureBaseFormComponent extends EmailCaptureFormComponent {
    onError(error) {
        this._onErrorCallback(error);
    }
}
